<!--
(수정내용)
#220923

  name : 김장호
  desc :
  date : 2020-07-08
-->
<template>
  <v-container id="main">
    <div id="wrap">
      <!--floating-->
      <div id="floating" @click="GoDown"></div>
      <!-- //floating-->
      <div id="container">
        <header>
          <div
            class="header"
            :class="{
              original_color: scrollPosition < 1,
              st99: scrollPosition > 1
            }"
          >
            <div class="header_wrap" :class="{ on: hidden }">
              <h1>
                <a href="/"><span class="logo_header">로고</span></a>
              </h1>
              <nav class="gnb">
                <h2 class="blind">메인 메뉴</h2>
                <!-- <div class="header_link">
							<h2 class="blind">로그인메뉴</h2>
							<ul>
								<li><a href="" class="icon_login">로그인</a></li>
								<li><a href="" class="icon_logout">회원가입</a></li>
							</ul>
						</div> -->
                <div class="mobile_btn">
                  <button class="menu" @click="toggle">리스트</button>
                </div>
                <ul class="menu_main" :class="{ on: hidden }">
                  <li class="menu menu_btn" @click="goPayment">요금제</li>
                  <li class="menu menu_btn" @click="goMain">
                    <a href="#goPMI">도입문의</a>
                  </li>
                  <li class="header_link">
                    <!--로그인 이동-->
                    <v-btn
                      class="btn_top_bar00"
                      @click="login"
                      v-if="!getName()"
                      >로그인</v-btn
                    >
                    <v-btn class="btn_top_bar00" @click="home" v-if="getName()"
                      >전자계약 홈</v-btn
                    >
                    <v-btn
                      class="btn_top_bar00"
                      @click="logout"
                      v-if="getName()"
                      >로그아웃</v-btn
                    >
                    <!--회원가입 이동-->
                    <v-btn
                      class="btn_top_bar00"
                      @click="goJoin"
                      v-if="!getName()"
                      >회원가입</v-btn
                    >
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </header>
        <div class="header_overlay"></div>
        <v-row no-gutters id="content" class="main">
          <v-col cols="12" class="section_main main_img">
            <div class="content">
              <h2>웹·연동 완벽호환의<br />완전한 전자계약</h2>
              <a href="#goPMI" class="btn_main"><span>도입 문의</span></a>
            </div>
          </v-col>
          <v-col cols="12" class="proMbanner-0">
          </v-col>
          <v-col cols="12" class="section_safe">
            <div class="content">
              <h3>
                글로싸인엔터프라이즈는 10여년간 운영해 온<br />안정적인 전자계약
                서비스입니다
              </h3>
              <div class="row no-gutters justify-center">
                <div class="pad_img">
                  <div class="slide">
                    <ul>
                      <li>
                        <v-img
                          src="../../assets/img/pad_img1.png"
                          alt=""
                        ></v-img>
                      </li>
                      <li>
                        <v-img
                          src="../../assets/img/pad_img2.png"
                          alt=""
                        ></v-img>
                      </li>
                      <li>
                        <v-img
                          src="../../assets/img/pad_img3.png"
                          alt=""
                        ></v-img>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="li_safe">
                  <ul>
                    <li>
                      <strong class="tit">맞춤형 구축 방식 지원</strong>
                      <span class="ct"
                        >고객사 상황에 맞는 구축 컨설팅 <br />
                        웹/SaaS/연동 방식 지원</span
                      >
                    </li>
                    <li>
                      <strong class="tit">비용·업무 리소스 절약</strong>
                      <span class="ct"
                        >계약서 전달 비용·리소스 70% 절감 <br />
                        계약서 보관·관리 비용 0원</span
                      >
                    </li>
                    <li>
                      <strong class="tit">뛰어난 업무 효율성</strong>
                      <span class="ct"
                        >서명 및 인증방법의 자유로운 선택<br />
                        계약 작성, 전달, 보관까지 한 번에!</span
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" class="section_infra">
            <div class="content">
              <h3>
                글로싸인엔터프라이즈는 업계 최고 수준의<br />전자계약 연동
                인프라를 보유하고 있습니다
              </h3>
              <v-row no-gutters>
                <v-col cols="12" sm="4" md="4" lg="4">
                  <div class="bdr">
                    <span class="img inf1"></span>
                    <span class="txt">다양한 연동 레퍼런스</span>
                  </div>
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4">
                  <div class="bdr">
                    <span class="img inf2"></span>
                    <span class="txt">구축·보수 전문인력 보유</span>
                  </div>
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4">
                  <div class="bdr">
                    <span class="img inf3"></span>
                    <span class="txt">직영 고객센터 운영</span>
                  </div>
                </v-col>
              </v-row>
              <v-row no-gutters class="justify-center">
                <v-col cols="12" sm="4" md="4" lg="4">
                  <div class="bdr">
                    <span class="img inf4"></span>
                    <span class="txt">서비스기간 (‘07~)</span>
                  </div>
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4">
                  <div class="bdr">
                    <span class="img inf5"></span>
                    <span class="txt">보안·기술 이슈 건수</span>
                  </div>
                </v-col>
              </v-row>
              <p class="txt2">
                <span
                  >동사 타솔루션인 전자세금계산서 ‘스마트빌’ 연동 경험 1,500회
                  이상</span
                >
              </p>
            </div>
          </v-col>
          <v-col cols="12" class="section_effect">
            <div class="content">
              <h3>
                글로싸인엔터프라이즈 연동시스템으로<br />업무 효율을 높일 수
                있습니다
              </h3>
              <v-row no-gutters>
                <v-col cols="12" sm="4" md="4" lg="4">
                  <div class="bdr">
                    <span class="pic eff1"></span>
                    <strong class="tit">ERP 직접 연동</strong>
                    <span class="ct"
                      >ERP와 전자계약 데이터가 연계되어 입력 수작업을 최소화 할
                      수 있습니다</span
                    >
                  </div>
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4">
                  <div class="bdr">
                    <span class="pic eff2"></span>
                    <strong class="tit">CS 업무 리소스 절감</strong>
                    <span class="ct"
                      >글로싸인엔터프라이즈 직영 고객센터에서 관련 CS를
                      처리합니다</span
                    >
                  </div>
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4">
                  <div class="bdr">
                    <span class="pic eff3"></span>
                    <strong class="tit">구축 비용 절약</strong>
                    <span class="ct"
                      >자체 솔루션과 효과는 비슷하지만, 도입 비용은 크게 절감할
                      수 있습니다</span
                    >
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col cols="12" class="section_linkage">
            <div class="content">
              <h3>
                고객사 시스템 환경에 맞는<br />최적의 연동 방식을 제안해드립니다
              </h3>
              <v-img
                class="link_img"
                src="../../assets/img/linkage_img.png"
                alt=""
              ></v-img>
            </div>
          </v-col>
          <v-col cols="12" class="section_conve">
            <div class="content">
              <h3>안정적인 기술력에<br />업무 편의성을 더했습니다</h3>
              <v-row no-gutters>
                <v-col cols="12" sm="4" md="4" lg="4">
                  <span class="spec">spec 1</span>
                  <strong class="tit"
                    >서명 방식(공동인증/간편)<br />선택 가능</strong
                  >
                  <span class="ct"
                    >공동인증 서명과 간편인증 서명 중 상황에 맞는 서명을
                    선택해보세요.</span
                  >
                  <span class="pic conv1"></span>
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4">
                  <span class="spec">spec 2</span>
                  <strong class="tit"
                    >자유로운 수신자 인증 방식<br />선택</strong
                  >
                  <span class="ct"
                    >공동인증서(법인/개인), 휴대폰 인증, 인증키, 무인증 방법을
                    선택할 수 있습니다</span
                  >
                  <span class="pic conv2"></span>
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4">
                  <span class="spec">spec 3</span>
                  <strong class="tit">대량 발송 및 자동치환<br />기능</strong>
                  <span class="ct"
                    >대량 발송이 가능하며 수신자 정보가 계약서에 자동 치환되어
                    업무시간이 절약됩니다</span
                  >
                  <span class="pic conv3"></span>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col cols="12" class="section_law">
            <div class="content">
              <h3>
                글로싸인엔터프라이즈의 계약 효력은<br />법적으로 보장됩니다
              </h3>
              <v-row no-gutters>
                <v-col cols="12" sm="6" md="6" lg="6"
                  ><div class="bdr">
                    <span class="bold"
                      >[전자문서및전자거래기본법 제4조 제1항]</span
                    >
                    과 <span class="bold">[전자서명법 제3조 제3항]</span> 에
                    따라 종이계약과 동일한 법적효력을 가지고 있습니다
                  </div></v-col
                >
                <v-col cols="12" sm="6" md="6" lg="6"
                  ><div class="bdr pd02">
                    블록체인에 모든 계약 로그가 기록되어 위변조가 불가능하며
                    실시간 조회가 가능합니다
                  </div></v-col
                >
              </v-row>
            </div>
          </v-col>
          <v-col cols="12" class="section_customer">
            <div class="content">
              <h3>
                많은 대기업·공기업에서<br />글로싸인엔터프라이즈를 사용하고
                있습니다
              </h3>
              <v-row no-gutters>
                <v-col cols="12">
                  <div class="btn_con">
                    <!-- k2<button class="ptn_btn" type="button" name="button" @click="youtube1 = !show, youtube2 = hidden, activeButton = 0" v-bind:class="{'on': activeButton == 0}"><span class="fw_700">케이투코리아</span><br><span>대리점 계약</span></button>-->
                    <!-- k2<button class="ptn_btn" type="button" name="button" @click="youtube2 = !show, youtube1 = hidden, activeButton = 1" v-bind:class="{'on': activeButton == 1}"><span class="fw_700">삼양사</span><br><span>하도급 계약</span></button>-->
                    <button class="ptn_btn on" type="button" name="button">
                      <span class="fw_700">삼양사</span><br /><span
                        >하도급 계약</span
                      >
                    </button>
                  </div>
                </v-col>
                <!-- k2
            <v-col cols="12" v-show="youtube1">
                <p>“ERP 연동 방식으로 저렴한 가격에 맞춤 솔루션이 가능합니다”</p>
                <iframe class="Uvideo-con" width="100%" height="auto" src="https://www.youtube.com/embed/sZ3PSCD5Xz4" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </v-col>
            v-col 삭제: v-show="youtube2"
            -->
                <v-col cols="12">
                  <p>
                    “프로젝트 일정이 단축되는 걸 보면서 이제 시대가
                    바뀌었구나라는걸 느꼈습니다”
                  </p>
                  <iframe
                    class="Uvideo-con"
                    width="100%"
                    height="auto"
                    src="https://www.youtube.com/embed/yIwvL5OfGGU"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </v-col>
              </v-row>
              <v-row no-gutters max-width="720px">
                <v-col>
                  <p class="tit">주요고객사</p>
                  <v-carousel class="ptnBnn" hide-delimiters cycle>
                    <v-carousel-item>
                      <v-row no-gutters class="ptn_row">
                        <v-col cols="12"
                          ><v-img
                            src="../../assets/img/main_ptn_logo01.gif"
                            alt="삼성/현대/한샘/LG"
                          ></v-img
                        ></v-col>
                      </v-row>
                    </v-carousel-item>
                    <v-carousel-item class="ptn_row">
                      <v-row no-gutters class="ptn_row">
                        <v-col cols="12"
                          ><v-img
                            src="../../assets/img/main_ptn_logo02.gif"
                            alt="풀무원/동원/야놀자/코오롱"
                          ></v-img
                        ></v-col>
                      </v-row>
                    </v-carousel-item>
                    <v-carousel-item class="ptn_row">
                      <v-row no-gutters class="ptn_row">
                        <v-col cols="12"
                          ><v-img
                            src="../../assets/img/main_ptn_logo03.gif"
                            alt="경동도시가스/삼양/GC녹십자/한솔"
                          ></v-img
                        ></v-col>
                      </v-row>
                    </v-carousel-item>
                  </v-carousel>
                  <a
                    href="http://www.smartbill.co.kr/Svc/dct/dct_intro05.aspx
	"
                    target="_blank"
                    class="cust_btn"
                    ><span>더보기</span></a
                  >
                </v-col>
              </v-row>
              <!--
					<p class="tit">연동고객</p>
					<div class="cust_img link"></div>
					<p class="tit">웹고객</p>
					<div class="cust_img web" ></div>
					<a href="http://www.smartbill.co.kr/Svc/dct/dct_intro05.aspx
" target="_blank" class="cust_btn"><span>더보기</span></a>
-->
            </div>
          </v-col>
          <v-col cols="12" class="section_conve">
            <div id="goPMI" class="content">
              <h3>도입문의</h3>
              <p>전문 상담사가 빠르게 답변해드리겠습니다</p>
              <div id="popMainInq">
                <div class="form_box">
                  <form class="" action="#" method="#">
                    <v-row no-gutters class="PMI_ul_form">
                      <v-col class="st_email" cols="12" sm="12" md="6" lg="6">
                        <span class="icon"></span>
                        <div class="PMI_input">
                          <v-text-field
                            class="inputH48_MM"
                            placeholder="이메일"
                            outlined
                            v-model="svcForm.Email"
                          >
                          </v-text-field>
                        </div>
                      </v-col>
                      <v-col class="st_phone" cols="12" sm="12" md="6" lg="6">
                        <span class="icon"></span>
                        <div class="PMI_input">
                          <v-text-field
                            class="inputH48_MM"
                            placeholder="전화번호"
                            outlined
                            dense
                            v-model="svcForm.Phone"
                          >
                          </v-text-field>
                        </div>
                      </v-col>
                      <v-col class="st_cpn" cols="12" sm="12" md="6" lg="6">
                        <span class="icon"></span>
                        <div class="PMI_input">
                          <v-text-field
                            class="inputH48_MM"
                            placeholder="회사명"
                            outlined
                            dense
                            v-model="svcForm.Cpn"
                          >
                          </v-text-field>
                        </div>
                      </v-col>
                      <v-col class="st_sum" cols="12" sm="12" md="6" lg="6">
                        <span class="icon"></span>
                        <div class="PMI_input">
                          <v-text-field
                            class="inputH48_MM"
                            placeholder="월 평균 계약건수"
                            outlined
                            dense
                            v-model="svcForm.Sum"
                          >
                          </v-text-field>
                        </div>
                      </v-col>
                      <v-col class="st_inq" cols="12" sm="12" md="12" lg="12">
                        <span class="icon"></span>
                        <div class="PMI_input">
                          <v-textarea
                            class="inputH48_MM W100Hauto conBstar"
                            outlined
                            no-resize
                            placeholder="문의내용"
                            rows="8"
                            row-height="60"
                            v-model="svcForm.Inq"
                          ></v-textarea>
                        </div>
                      </v-col>
                    </v-row>
                    <!--
						<ul class="PMI_ul_form">
						  <li class="st_email"><span class="icon"></span>
						  <input type="text" autocomplete="off" placeholder="이메일" class="el-input__inner">
						  </li>
						  <li class="st_phone"><span class="icon"></span><input type="text" autocomplete="off" placeholder="전화번호" class="el-input__inner"></li>
						  <li class="st_cpn"><span class="icon"></span><input type="text" autocomplete="off" placeholder="회사명" class="el-input__inner"></li>
						  <li class="st_sum"><span class="icon"></span><input type="text" autocomplete="off" placeholder="월 평균 계약건수" class="el-input__inner"></li>
						  <li class="st_inq"><span class="icon"></span><textarea class="note-codable" role="textbox" aria-multiline="true"  placeholder="문의내용"></textarea></li>
						</ul>-->
                    <div class="chk_con">
                      <v-checkbox
                        v-model="svcForm.ChkYN"
                        class="coNlist_chk size_s mb-5"
                        label="[필수] 개인정보 수집 및 이용에 동의합니다"
                      ></v-checkbox>
                      <div class="scroll_bs_tbl">
                        <table class="st_b_tbl">
                          <colgroup>
                            <col width="24%" />
                            <col width="20%" />
                            <col width="56%" />
                          </colgroup>
                          <tr>
                            <th>수집 및 이용목적</th>
                            <th>수집항목</th>
                            <th>보유 및 이용기간</th>
                          </tr>
                          <tr>
                            <td>
                              서비스 도입문의 등록 및 문의 내용 답변을 위한 정보
                              확인
                            </td>
                            <td>회사명, 이메일,연락처, 문의내용</td>
                            <td>
                              개인정보는 원칙적으로 개인정보의 수집 및 이용
                              목적이 달성되면 지체 없이 파기합니다<br />
                              단, 관계 법령에 따라 고객님의 개인정보를 보존
                              하여야 하는 경우, 회사는 해당 법령에서 정한 기간
                              동안 보관합니다
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                    <div class="btn_con">
                      <button
                        class="pMI_btn01"
                        type="button"
                        name="button"
                        @click="fnSvcInsert"
                      >
                        <span>문의 남기기</span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
        <footer>
          <div class="footer">
            <v-row no-gutters>
              <v-col cols="12" sm="3" md="3" lg="3"
                >(주)비즈니스온커뮤니케이션</v-col
              >
              <v-col cols="12" sm="5" md="5" lg="5"
                >06147 서울시 강남구 언주로 520(역삼동) 대세700 빌딩, 9~12층</v-col
              >
              <v-col cols="12" sm="4" md="4" lg="4">고객센터 1588-8064</v-col>
            </v-row>
            <v-row no-gutters class="mt-2">
              <v-col cols="12" sm="3" md="3" lg="3"
                >대표이사: 노태완</v-col
              >
              <v-col cols="12" sm="5" md="5" lg="5">
                <v-row no-gutters>
                  <v-col cols="12" sm="6" md="6" lg="6" class="nopd"
                    >사업자등록번호: 220-87-58882</v-col
                  >
                  <v-col cols="12" sm="6" md="6" lg="6" class="nopd"
                    >통신판매업: 서울강남-05259</v-col
                  >
                </v-row>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="4"
                >개인정보 보호책임자: 곽상훈(privacy@businesson.co.kr)
              </v-col>
            </v-row>
            <div class="fmenu_wrap">
              <div class="fmenu">
                <ul>
                  <li v-on:click="userAgree" class="poinTer">이용약관</li>
                  <li v-on:click="personInfo" class="poinTer_2">
                    개인정보처리방침
                  </li>
                </ul>
              </div>
              <div class="copy">
                Copyright ⓒ BusinessOn Communication Co., Ltd. All rights
                reserved.
              </div>
            </div>
          </div>
        </footer>
        <s-confirm ref="confirm"></s-confirm>
        <s-loading ref="loading"></s-loading>
        <userAgreement ref="userAgreement"></userAgreement>
        <perInfoProtec ref="perInfoProtec"></perInfoProtec>
      </div>
    </div>

    <!--#220923 팝업
    <v-dialog
      id="mw1264_fix100"
      v-model="popNoti220923"
      max-width="600"
      persistent
      hide-overlay
    >
      <v-card id="popupBox" class="popDocuD_pd_bt">
        <v-card-title class="noti_pop_title align-start">
          <v-btn
            fab
            class="popBtnClose"
            style="right:20px;"
            @click="popNoti220923 = false"
          ></v-btn>
          <h1 class="carD_01_h1-221005">스마트빌싸인 서비스명 변경 안내</h1>
        </v-card-title>
        <v-card-text
          class="noti_pop_con for_dashB"
          style="letter-spacing:-.024em; text-align:center;"
        >
          안녕하세요? 비즈니스온커뮤니케이션 입니다.<br /><br />
          보다 나은 서비스 제공을 위해 <br />
          비즈니스온커뮤니케이션이 제공하는 전자서명 서비스 <br />
          <span style="color:#333;"
            >'스마트빌싸인'이
            <font style="color:#1e8ffa;">'글로싸인엔터프라이즈'</font>로
            서비스명을 변경합니다.</span
          ><br />
          <div class="noti220923_Box">
            <font style="color:#f95f43;"
              >서비스명 변경일자 : 2022년 10월 12일 19시</font
            ><br /><br />
            <ul>
              <li>
                - 서비스명 변경과 관계없이 서비스 기능 및 사용자 접속 환경에는
                변동이 없습니다.
              </li>
              <li>- 기존 수·발신 계약서는 그대로 보존됩니다.</li>
              <li>
                - 서비스명 변경 후에도 전자계약 발송 및 수신 업무는 동일하게
                진행됩니다.
              </li>
            </ul>
          </div>
          <div style="margin-bottom:40px; text-align:center;">
            <img
              src="@/assets/img/logo.svg"
              width="201"
              height="auto"
              class="logoColor"
              alt="Glosign enterprise"
            />
          </div>
        </v-card-text>
        <v-card-actions class="justify-center btnPopcon">
          <v-checkbox
            danse
            label="오늘하루 보지 않기"
            @click="skipPopup()"
          ></v-checkbox>
        </v-card-actions>
        <v-card-actions class="justify-center btnPopcon">
          <v-btn text @click="popNoti220923 = false">닫기</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    /팝업-->

    <v-dialog
      id="mw1264_fix100"
      v-model="popNoti250123"
      max-width="500"
      persistent
      hide-overlay
      style=" width: 500px; height: 600px;"
    >
      <v-card id="popupBox" class="popDocuD_pd_bt" style="position: relative; height: 100%;">

          <v-img
            :src="require('@/assets/img/body-web-popup_250122.svg')"
            alt="Popup Image"
            contain
            max-width="100%"
            max-height="100%"
            style="width: 100%; height: 100%;"
          />

        <!-- 닫기 버튼 -->
        <v-card-actions class="justify-center btnPopcon">
          <v-btn text @click="popNoti250123 = false">닫기</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>
<script>
import { setSvcAsk } from "@/api/cs/svcAsk";
import userAgreement from "@/components/userAgreement";
import perInfoProtec from "@/components/perInfoProtec";

export default {
  name: "mainPage",
  components: {
    userAgreement,
    perInfoProtec
  },
  filters: {},
  data() {
    return {
      // 220923 서비스명 공지 팝업
      // popNoti220923: true,
      popNoti250123: true,
      svcForm: {
        Sum: "",
        Email: "",
        Phone: "",
        Cpn: "",
        Inq: "",
        ChkYN: false
      },
      // class 추가
      hidden: false,
      // 유튜브 보기 버튼 show
      // youtube1: true,
      // youtube2: false,
      activeButton: 0,
      // header 스크롤
      scrollPosition: null
    };
  },
  created() {},
  mounted() {
    this.track();
    // header 스크롤
    window.addEventListener("scroll", this.updateScroll);
    var closePopup = this.getCookie("closePopup");
    console.log("closePopup", closePopup);

    // 25년 1월 30일까지만 팝업 활성화
    let today = new Date();
    let popupFinishDate = new Date('2025-01-31 00:00');

    if(today.getTime() > popupFinishDate.getTime()) {
      this.popNoti250123 = false;
    }

    // if (closePopup === "") {
    //   // 오늘 하루 보지 않기 체크하지 않은 경우
    //   this.popNoti220923 = true;
    // } else {
    //   // 오늘 하루 보지 않기 체크한 경우
    //   this.popNoti220923 = false;
    // }
  },
  methods: {
    skipPopup() {
      this.setCookie("closePopup", "closePopup", 1);
    },
    setCookie(cookieName, value, exdays) {
      var exdate = new Date();
      exdate.setDate(exdate.getDate() + exdays);
      var cookieValue =
        escape(value) +
        (exdays === null ? "" : "; expires=" + exdate.toGMTString());
      document.cookie = cookieName + "= " + cookieValue;
    },
    getCookie(cookieName) {
      cookieName = cookieName + "=";
      var cookieData = document.cookie;
      var start = cookieData.indexOf(cookieName);
      var cookieValue = "";
      if (start !== -1) {
        start += cookieName.length;
        var end = cookieData.indexOf(";", start);
        if (end === -1) end = cookieData.length;
        cookieValue = cookieData.substring(start, end);
      }
      return unescape(cookieValue);
    },
    track() {
      this.$gtag.pageview({
        page_path: "/index"
      });
    },
    // header 스크롤
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    // 모바일 버튼 토글
    toggle() {
      this.hidden = !this.hidden;
    },
    trackEvent() {
      this.$gtag.event("도입문의_클릭", {
        event_category: "글로싸인엔터프라이즈",
        event_label: "도입문의_클릭"
      });
    },
    login() {
      this.$router.push({ name: "login" });
    },
    home() {
      this.$router.push({ name: "dashboard" });
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        this.$router.push({ name: "main" });
        location.reload();
      });
    },
    getName() {
      this.userName = this.$store.state.user.username;
      if (
        this.$store.state.user.urtoken === undefined ||
        this.$store.state.user.urtoken === ""
      ) {
        return false;
      } else {
        return true;
      }
    },
    GoDown() {
      this.$gtag.event("제안서다운_클릭", {
        event_category: "글로싸인엔터프라이즈",
        event_label: "제안서다운_클릭"
      });
      window.open("https://forms.gle/M9zDAXkM6bPqR3j89", "_blank");
    },
    userAgree() {
      this.$refs.userAgreement.open();
    },
    personInfo() {
      this.$refs.perInfoProtec.open();
    },
    goJoin() {
      this.$router.push({ name: "join" });
    },
    fnSvcInsert() {
      var emailRule = /([\w-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
      var Phone = /^\d{3}\d{3,4}\d{4}$/;

      if (!emailRule.test(this.svcForm.Email.trim())) {
        this.$refs.confirm.open(
          "alert",
          "도입문의",
          "이메일 형식을 확인 해주세요."
        );
        return true;
      } else if (!Phone.test(this.svcForm.Phone.trim())) {
        this.$refs.confirm.open(
          "alert",
          "도입문의",
          "핸드폰번호 형식을 확인 해주세요."
        );
        return true;
      } else if (this.svcForm.Cpn.trim().length === 0) {
        this.$refs.confirm.open("alert", "도입문의", "회사명을 입력 해주세요.");
        return true;
      } else if (this.svcForm.Sum.trim().length === 0) {
        this.$refs.confirm.open(
          "alert",
          "도입문의",
          "월 평균 계약건수를 입력 해주세요."
        );
        return true;
      } else if (this.svcForm.Inq.trim().length === 0) {
        this.$refs.confirm.open(
          "alert",
          "도입문의",
          "문의 내용을 입력 해주세요."
        );
        return true;
      } else if (this.svcForm.ChkYN === false) {
        this.$refs.confirm.open(
          "alert",
          "도입문의",
          "개인정보 수집 이용에 동의 해주시기 바랍니다."
        );
        return true;
      } else {
        this.$refs.loading.start("도입문의 작성중입니다.");
        setSvcAsk({ params: this.svcForm })
          .then(Response => {
            if (Response.rdata.rcode === 30000) {
              this.$refs.loading.end();
              this.svcForm.Email = "";
              this.svcForm.Phone = "";
              this.svcForm.Cpn = "";
              this.svcForm.Sum = "";
              this.svcForm.Inq = "";
              this.svcForm.ChkYN = false;
              this.$refs.confirm.open(
                "alert",
                "도입문의",
                "서비스 도입문의 작성이 완료되었습니다."
              );
              this.trackEvent();
            }
          })
          .catch(e => {
            this.$refs.loading.end();
            this.$refs.confirm.open(
              "alert",
              "도입문의",
              "서비스 도입문의 작성이 실패하였습니다."
            );
          });
      }
    },
    goPayment() {
      this.$router.push({ name: "paymentInfo" });
    },
    goMain() {
      this.$router.push({ name: "main" });
    }
  }
};
</script>
<style scoped>
@import url(https://fonts.googleapis.com/earlyaccess/notosanskr.css);
@font-face {
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 100;
  src: url(https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Thin.woff2)
      format("woff2"),
    url(https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Thin.woff)
      format("woff"),
    url(https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Thin.otf)
      format("opentype");
}
@font-face {
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 300;
  src: url(https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Light.woff2)
      format("woff2"),
    url(https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Light.woff)
      format("woff"),
    url(https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Light.otf)
      format("opentype");
}
@font-face {
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 400;
  src: url(https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Regular.woff2)
      format("woff2"),
    url(https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Regular.woff)
      format("woff"),
    url(https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Regular.otf)
      format("opentype");
}
@font-face {
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 500;
  src: url(https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Medium.woff2)
      format("woff2"),
    url(https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Medium.woff)
      format("woff"),
    url(https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Medium.otf)
      format("opentype");
}
@font-face {
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 700;
  src: url(https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Bold.woff2)
      format("woff2"),
    url(https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Bold.woff)
      format("woff"),
    url(https://fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Bold.otf)
      format("opentype");
}

#main.container {
  width: 100%;
  max-width: 100%;
}
input[type="text"],
input[type="email"],
input[type="number"],
button,
input[type="submit"],
input[type="reset"],
button,
input[type="tel"],
button,
input[type="password"],
input[type="url"],
input[type="search"],
input[type="file"],
button,
textarea {
  -webkit-appearance: none;
  appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  -o-appearance: none;
  border-radius: 0;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  margin: 0;
  padding: 0;
  font-family: "NanumSquare", "Open Sans", sans-serif;
  border: none;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -o-box-sizing: border-box;
  background: none;
  font-size: 100%;
}
body {
  text-size-adjust: none;
  -webkit-text-size-adjust: none;
  -moz-text-size-adjust: none;
  position: relative;
  background: #fff;
  word-break: keep-all;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
  font-size: 14px;
  line-height: 1.8;
  color: #666666;
}
ol,
ul {
  list-style: none;
}
blockquote,
q {
  quotes: none;
}
input:focus,
button:focus {
  border: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
ul,
ol,
li {
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}
a:focus {
  outline: none !important;
}
a {
  text-decoration: none;
}
:invalid {
  box-shadow: none;
}
:-moz-submit-invalid {
  box-shadow: none;
}
:-moz-ui-invalid {
  box-shadow: none;
}
button::-moz-focus-inner {
  border: 0;
  padding: 0;
  margin-top: -2px;
  margin-bottom: -2px;
}
input::-moz-focus-inner {
  border: 0;
  padding: 0;
  margin-top: -2px;
  margin-bottom: -2px;
}
img {
  max-width: 100%;
}
button:hover {
  cursor: pointer;
}
button {
  background: transparent;
}
.just_contact_form {
  padding: 0px;
}
textarea:focus {
  outline: none;
}
:focus {
  outline: none;
}
html {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-y: scroll;
  font-size: 20px !important;
}
.mauto {
  margin: 0 auto;
}

/* ==== GRID SYSTEM ==== */

.container {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

.row {
  position: relative;
  width: 100%;
}

.row [class^="col"] {
  padding: 0.5rem 2%;
  min-height: 0.125rem;
}

.col-1,
.col-2,
.col-3,
.col-4,
.col-5,
.col-6,
.col-7,
.col-8,
.col-9,
.col-10,
.col-11,
.col-12 {
  width: 96%;
}

.col-1-sm {
  width: 4.33%;
}

.col-2-sm {
  width: 12.66%;
}

.col-3-sm {
  width: 21%;
}

.col-4-sm {
  width: 29.33%;
}

.col-5-sm {
  width: 37.66%;
}

.col-6-sm {
  width: 46%;
}

.col-7-sm {
  width: 54.33%;
}

.col-8-sm {
  width: 62.66%;
}

.col-9-sm {
  width: 71%;
}

.col-10-sm {
  width: 79.33%;
}

.col-11-sm {
  width: 87.66%;
}

.col-12-sm {
  width: 96%;
}
.hidden-sm {
  display: none;
}

@media only screen and (min-width: 33.75em) {
  /* 540px */
  .container {
    width: 80%;
  }
}

@media only screen and (min-width: 45em) {
  /* 45em 720px */
  .col-1 {
    width: 4.33%;
  }

  .col-2 {
    width: 12.66%;
  }

  .col-3 {
    width: 21%;
  }

  .col-4 {
    width: 29.33%;
  }

  .col-5 {
    width: 37.66%;
  }

  .col-6 {
    width: 46%;
  }

  .col-7 {
    width: 54.33%;
  }

  .col-8 {
    width: 62.66%;
  }

  .col-9 {
    width: 71%;
  }

  .col-10 {
    width: 79.33%;
  }

  .col-11 {
    width: 87.66%;
  }

  .col-12 {
    width: 96%;
  }

  .hidden-sm {
    display: block;
  }
}

@media only screen and (min-width: 60em) {
  /* 960px */
  .container {
    width: 75%;
    max-width: 60rem;
  }
}
/*main.css*/
.btn_top_bar00 {
  margin-right: 14px;
  padding: 0 24px 0 24px !important;
  width: auto;
  height: 36px !important;
  line-height: 36px !important;
  font-size: 0.75rem !important;
  border-radius: 18px;
}

/* common */
h2 {
  font-size: 56px;
  font-weight: 500;
  line-height: 1.35;
}
h3 {
  font-size: 42px;
  font-weight: 500;
  line-height: 1.35;
  letter-spacing: -0.01em;
  margin-bottom: 80px;
}
h4 {
  font-size: 22px;
}
h5 {
  font-size: 18px;
}
.blind {
  position: absolute;
  overflow: hidden;
  clip: rect(0 0 0 0);
  margin: -1px;
  width: 1px;
  height: 1px;
}
.fl {
  display: block;
  float: left;
}
.fr {
  display: block;
  float: right;
}
.ofh {
  overflow: hidden;
}

@media screen and (max-width: 1023px) and (min-width: 1px) {
  h2 {
    font-size: 42px;
  }
  h3 {
    font-size: 32px;
    margin-bottom: 40px;
  }
}

@media screen and (max-width: 719px) and (min-width: 1px) {
  h2 {
    font-size: 38px;
  }
  h3 {
    font-size: 24px;
    margin-bottom: 30px;
  }
}

@media screen and (max-width: 500px) and (min-width: 1px) {
  h2 {
    font-size: 30px;
  }
}

/* header */
#wrap {
  overflow: hidden;
}
.header {
  width: 100%;
  height: 80px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  position: fixed;
  z-index: 10;
}
.header_wrap {
  margin: 0 auto;
  max-width: 1240px;
  height: 100%;
}
.header h1 {
  padding: 23px 40px 0 20px;
  float: left;
}
.logo_header {
  cursor: pointer;
  margin-top: 5px;
  display: block;
  width: 201px;
  height: 27px;
  background-image: url("../../assets/img/logo-w.svg");
  text-indent: -999999px;
}
.gnb {
  padding-top: 10px;
}
.header::after {
  display: block;
  content: "";
  clear: both;
}
.gnb .menu_main {
  float: right;
}
.gnb .menu_main li {
  position: relative;
  padding: 15px;
  float: left;
}
.gnb .menu_main li.menu a {
  font-size: 16px;
  color: #fff;
  line-height: 37px;
}
.gnb .menu_main li.menu :last-child {
  padding-right: 25px;
}
.header_link a {
  display: inline-block;
  padding: 4px 24px;
  font-size: 15px;
  color: #333;
  border: 1px solid #fff;
  border-radius: 20px;
  background: #fff;
}
.header_link a + a {
  margin-left: 10px;
}
.header_link :last-child {
  margin-right: 0;
}
.gnb .mobile_btn {
  float: right;
}
.gnb .mobile_btn .menu {
  display: none;
}
.menu_main .menu_btn {
  cursor: pointer;
  font-size: 16px;
  color: #fff;
  line-height: 37px;
}

.header.st99 {
  transition: 0.3s ease-in-out;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.2);
}
.header.st99 .logo_header {
  background-image: url("../../assets/img/logo.svg");
}
.header.st99 .gnb .menu_main li a,
.header.st99 .menu_main .menu_btn {
  color: #060c15;
}

.header_overlay {
  display: none;
}

@media screen and (max-width: 960px) {
  .header.original_color {
    background-color: #fff;
  }
  .header.original_color .logo_header {
    background-image: url("../../assets/img/logo.svg");
  }
  .header .gnb .mobile_btn {
    padding: 0;
    padding-right: 10px;
    height: 1px;
  }
  .header .gnb .mobile_btn .menu {
    background: url("../../assets/img/baseline_menu.png");
  }
  .header .gnb {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
  .gnb .mobile_btn {
    float: none;
  }
  .gnb .mobile_btn .menu {
    margin-left: 10px;
    display: block;
    background: url("../../assets/img/baseline_menu_wh.png");
    width: 36px;
    height: 36px;
    text-indent: -9999px;
  }
  .gnb .mobile_btn .menu.off {
    background: url("../../assets/img/baseline_close.png");
  }
  .gnb .menu_main {
    display: none;
  }
  .gnb .menu_main.on {
    display: block;
    float: none;
    position: absolute;
    top: 60px;
    width: 100%;
    background: #fff;
    border-top: 1px solid #b5b8bb;
    border-bottom: 1px solid #b5b8bb;
    padding: 0 4%;
  }
  .gnb .menu_main.on li {
    display: block;
    float: none;
    position: relative;
    padding: 10px 20px;
    border-bottom: 1px solid #c3c3c3;
  }
  .gnb .menu_main.on li:last-child {
    border-bottom: 0;
  }
  .gnb .menu_main.on li.menu,
  .gnb .menu_main.on li.menu a {
    font-size: 16px;
    color: #000;
    line-height: 28px;
  }
  .header {
    height: 60px;
  }
  .header h1 {
    padding: 10px 0 0 20px;
    float: none;
  }
  .logo_header {
    margin: auto;
    margin-top: 10px;
  }
  .header_link {
    text-align: center;
    margin: 10px 0;
  }
  .header_link a {
    border: 1px solid #999;
  }
  .header_overlay.on {
    background: rgba(0, 0, 0, 0.5);
    display: block;
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 998;
  }
}

@media screen and (max-width: 374px) {
  .logo_header {
    height: 30px;
    background-size: 80%;
  }
}

/* content */
.main .content {
  margin: 0 auto;
  padding: 55px 0;
  max-width: 1240px;
  text-align: center;
}
.main .content h3 {
  padding-top: 70px;
}
/*.main .content h3 {background-image:url('../../assets/img/symbol.png');background-position:50% 0;background-repeat:no-repeat;color:#000;background-size:45px;}*/
.main .content h3 {
  padding-top: 50px;
  color: #000;
  background-size: 45px;
}

/* footer */
footer {
  padding: 30px 0 20px;
  background: #202224;
}
.footer {
  margin: 0 auto;
  max-width: 1240px;
  font-size: 14px;
  font-weight: 100;
  color: #dbdbdb;
}
.footer > .row {
  padding: 0 2%;
}
.fmenu_wrap {
  margin: 20px 2%;
  padding-top: 10px;
  border-top: 1px solid #4d4e50;
}
.fmenu_wrap::after {
  display: block;
  content: "";
  clear: both;
}
.fmenu_wrap .fmenu {
  float: left;
}
.fmenu_wrap .fmenu a {
  font-size: 16px;
  color: #a8a9a9;
}
.fmenu_wrap .fmenu li {
  float: left;
  margin-right: 40px;
}
.fmenu_wrap .fmenu::after {
  display: block;
  content: "";
  clear: both;
}
.fmenu_wrap .copy {
  float: right;
  color: #a8a9a9;
}

#floating {
  position: fixed;
  left: 0px;
  bottom: 100px;
  z-index: 10;
  display: inline-block;
  width: 160px;
  height: 68px;
  background: url("../../assets/img/btn_down.png") center top no-repeat;
}
#floating a {
  display: block;
  width: 160px;
  height: 68px;
  text-indent: -9999px;
}

@media screen and (max-width: 1279px) and (min-width: 1024px) {
}

@media screen and (max-width: 1023px) and (min-width: 1px) {
  .main .content {
    padding: 30px 20px;
  }
}

@media screen and (max-width: 782px) {
  .main .content {
    padding: 30px 30px;
  }
}

@media screen and (max-width: 719px) {
  #floating {
    width: 68px;
    bottom: 7vh;
    background: url("../../assets/img/btn_down_m.png") left center no-repeat;
  }
  #floating a {
    display: none;
  }
  .fmenu_wrap .fmenu {
    float: none;
    width: 100%;
    margin-bottom: 6px;
  }
  .fmenu_wrap .copy {
    float: none;
    width: 100%;
    font-size: 0.6rem;
  }
  .footer {
    padding: 10px 0;
  }
  .row [class^="col"]:not(.nopd) {
    padding: 4px 2%;
  }
  .fmenu_wrap {
    margin: 10px 4%;
  }
  .fmenu_wrap .fmenu a {
    font-size: 0.7rem;
  }
}

@media screen and (max-width: 318px) and (min-width: 1px) {
  body {
    min-width: 320px;
  }
}

/* 비쥬얼 */
.section_main {
  background-color: #0c1420;
  background-image: url("../../assets/img/visual_bg_main.jpg");
  background-attachment: fixed;
}
.section_main.main_img {
  background-position: center top;
  background-repeat: no-repeat;
  color: #fff;
}
.section_main .content {
  margin: auto;
  max-width: 1240px;
}
.section_main h2 {
  padding: 180px 0 90px 0;
  text-align: center;
}
/*
.section_main .btn_main {display:inline-block;margin-bottom:60px;padding:0 86px;height:64px;line-height:64px;background-color:#6a0ff3;border-radius:10px}
.section_main .btn_main:hover {background-color:#7218fa;}
.section_main .btn_main span {color:#fff;font-size:23px;}
*/

.section_main .btn_main {
  display: inline-block;
  margin-bottom: 60px;
  padding: 0 78px 0 74px;
  height: 64px;
  line-height: 59px;
  background: url(../../assets/img/btn_main_pre.png) 186px 50% no-repeat;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(129, 132, 140, 0.8);
  border-radius: 10px;
}
.section_main .btn_main {
  -webkit-transition-duration: 0.4s; /* Safari */
  transition-duration: 0.4s;
}
.section_main .btn_main:hover {
  background-color: rgba(255, 255, 255, 0.2);
}
.section_main .btn_main span {
  padding: 0 20px 0 0;
  color: #fff;
  font-size: 23px;
  font-weight: 500;
  text-shadow: 1px 1px 1px #1e1e1e;
}

@media screen and (max-width: 719px) {
  .section_main h2 {
    padding: 140px 0 50px 0;
  }
  .section_main .btn_main {
    padding: 0 40px;
    margin-bottom: 80px;
    height: 50px;
    line-height: 50px;
  }
  .section_main .btn_main span {
    padding: 0;
    color: #fff;
    font-size: 18px;
  }
}
/* [띠배너]-0 3/16 ~ */
.proMbanner-0 {
  background-color: #3841e7;
}
.proMbanner-0 .proMb_cover_bg {
  margin: 0 auto;
  padding: 30px 60px;
  display: block;
  width: 100%;
  max-width: 1080px;
  height: auto;
  background: url(../../assets/img/proMbanner_bg.png) no-repeat center bottom;
}
.proMbanner-0 .proMb_txt {
  display: inline-block;
  width: 81%;
  vertical-align: baseline;
  text-align: left;
}
.proMbanner-0 .proMb_txt_pc {
  width: calc(100% - 40px);
  max-width: 544px;
  height: auto;
  margin-top: 8px;
  margin-right: 24%;
}
.proMbanner-0 .proMb_txt_mobile {
  display: none;
}
.proMbanner-0 .proMb_btn {
  width: 19%;
  height: auto;
  margin-bottom: 20px;
}
@media screen and (max-width: 719px) {
  .proMbanner-0 .proMb_txt {
    width: 100%;
  }
  .proMbanner-0 .proMb_txt_pc {
    width: 100%;
    max-width: 544px;
    height: auto;
    margin-right: 0;
    margin-bottom: 24px;
  }
  .proMbanner-0 .proMb_btn {
    width: auto;
    height: auto;
    margin-bottom: 0px;
  }
}
@media screen and (max-width: 540px) {
  .proMbanner-0 .proMb_cover_bg {
    padding: 34px 20px;
    background-position: 55% bottom;
    background-size: auto 120%;
  }
  .proMbanner-0 .proMb_txt_pc {
    display: none;
  }
  .proMbanner-0 .proMb_txt_mobile {
    display: block;
    width: auto;
    height: auto;
    margin-bottom: 34px;
  }
}

/* 안정적 */
.section_safe {
}
.section_safe .pad_img {
  width: 752px;
  padding: 34px 42px;
  background-image: url("../../assets/img/pad_bg.png");
  background-repeat: no-repeat;
  background-size: contain;
  float: left;
}
.section_safe .li_safe {
  float: left;
  margin-left: 50px;
}
.section_safe .li_safe ul::after {
  display: block;
  content: "";
  clear: both;
}
.section_safe .li_safe li {
  text-align: left;
}
.section_safe .li_safe li .tit {
  display: block;
  margin: 30px 0 15px;
  font-size: 30px;
  font-weight: 500;
  color: #7ca0f6;
}
.section_safe .li_safe li .ct {
  display: block;
  font-size: 16px;
  font-weight: 300;
}
.section_safe .li_safe li:first-child .tit {
  margin-top: 0;
}

@media screen and (max-width: 1100px) {
  .section_safe .li_safe {
    margin: 20px 0 0 10px;
  }
  .section_safe .li_safe li {
    float: left;
    margin: 0 30px 20px 0;
  }
  .section_safe .li_safe li:last-child {
    margin-right: 0;
  }
  .section_safe .li_safe li .tit {
    margin: 0 0 10px;
    font-size: 24px;
  }
}

@media screen and (max-width: 800px) {
  .section_safe .li_safe li .tit {
    font-size: 20px;
  }
  .section_safe .li_safe li .ct {
    font-size: 15px;
  }
}

@media screen and (max-width: 500px) and (min-width: 1px) {
  .section_safe .li_safe li {
    width: 100%;
  }
  .section_safe .li_safe li .tit {
    font-size: 20px;
    text-align: center;
  }
  .section_safe .li_safe li .ct {
    font-size: 15px;
    text-align: center;
  }
}

.slide {
  overflow: hidden;
}
.slide ul {
  width: calc(100% * 3);
  display: flex;
  animation: slide 8s infinite;
} /* slide를 8초동안 진행하며 무한반복 함 */
.slide li {
  width: calc(100% / 3);
}
.slide li:nth-child(1) {
}
.slide li:nth-child(2) {
}
.slide li:nth-child(3) {
}
@keyframes slide {
  0% {
    margin-left: 0;
  } /* 0 ~ 10  : 정지 */
  10% {
    margin-left: 0;
  } /* 10 ~ 25 : 변이 */
  30% {
    margin-left: -100%;
  } /* 25 ~ 35 : 정지 */
  40% {
    margin-left: -100%;
  } /* 35 ~ 50 : 변이 */
  60% {
    margin-left: -200%;
  }
  80% {
    margin-left: -200%;
  }
  100% {
    margin-left: 0;
  }
}

@media screen and (max-width: 782px) {
  .section_safe .pad_img {
    width: 700px;
    padding: 32px 42px;
  }
  .slide {
    overflow: hidden;
  }
}

@media screen and (max-width: 500px) {
  .section_safe .pad_img {
    width: 100%;
    padding: 24px 30px;
  }
  .slide {
    overflow: hidden;
  }
}

/* 인프라 */
.section_infra {
}
.section_infra .content {
  max-width: 1000px;
}
.section_infra .infra1 {
  max-width: 1000px;
  margin: 0 auto;
}
.section_infra .infra2 {
  max-width: 700px;
  margin: 0 auto;
}
.section_infra .bdr {
  border: 1px solid #eaeaea;
  border-radius: 20px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
}
.section_infra .img {
  display: block;
  margin: 50px auto 0;
  height: 100px;
}
.section_infra .img.inf1 {
  width: 188px;
  background-image: url("../../assets/img/infra_img1.png");
  background-position: 50% 30%;
  background-repeat: no-repeat;
}
.section_infra .img.inf2 {
  width: 143px;
  background-image: url("../../assets/img/infra_img2.png");
  background-position: 50% 35%;
  background-repeat: no-repeat;
}
.section_infra .img.inf3 {
  width: 74px;
  background-image: url("../../assets/img/infra_img3.png");
  background-position: 50% 30%;
  background-repeat: no-repeat;
}
.section_infra .img.inf4 {
  width: 129px;
  background-image: url("../../assets/img/infra_img4.png");
  background-position: 50% 35%;
  background-repeat: no-repeat;
}
.section_infra .img.inf5 {
  width: 70px;
  background-image: url("../../assets/img/infra_img5.png");
  background-position: 50% 35%;
  background-repeat: no-repeat;
}
.section_infra .txt {
  display: block;
  margin: 20px 0 60px 0;
  padding: 0 20px;
  font-size: 20px;
  font-weight: 300;
  line-height: 1.35;
}
.section_infra .txt2 {
  margin-top: 30px;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(113, 155, 246, 1) 30%,
    rgba(113, 155, 246, 1) 70%,
    rgba(255, 255, 255, 1) 100%
  );
}
.section_infra .txt2 span {
  display: inline-block;
  padding: 10px 0;
  font-size: 20px;
  color: #fff;
  font-weight: 300;
  line-height: 1.35;
  text-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
}

@media screen and (max-width: 880px) {
  .section_infra .img {
    margin-top: 30px;
    background-size: 80%;
  }
  .section_infra .txt {
    margin: 10px 0 40px 0;
    padding: 0 10px;
    font-size: 18px;
  }
  .section_infra .txt2 {
    padding: 0 50px;
  }
}

@media screen and (max-width: 719px) {
  .section_infra .img {
    margin-top: 20px;
    height: 60px;
    background-size: 50%;
  }
  .section_infra .txt {
    margin: 0 0 20px 0;
  }
  .section_infra .txt2 span {
    font-size: 18px;
  }
}

@media screen and (max-width: 374px) {
  .section_infra .txt2 span {
    font-size: 16px;
  }
}

/* 업무효율 */
.section_effect {
}
.section_effect .content {
  max-width: 1100px;
}
.section_effect .bdr {
  height: 100%;
  border: 1px solid #eaeaea;
  border-radius: 20px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
}
.section_effect .pic {
  display: block;
  height: 60px;
  margin: 60px auto 0;
  background-position: 0 50%;
  background-repeat: no-repeat;
}
.section_effect .eff1 {
  width: 89px;
  background-image: url("../../assets/img/effect_img1.png");
}
.section_effect .eff2 {
  width: 122px;
  background-image: url("../../assets/img/effect_img2.png");
}
.section_effect .eff3 {
  width: 118px;
  background-image: url("../../assets/img/effect_img3.png");
}
.section_effect .tit {
  display: block;
  margin: 40px 0 35px;
  font-size: 30px;
  font-weight: 500;
  color: #7ca0f6;
  line-height: 1.35;
  letter-spacing: -0.04em;
}
.section_effect .ct {
  display: block;
  padding: 0 60px 40px 60px;
  font-size: 16px;
  font-weight: 300;
  line-height: 1.45;
  word-break: keep-all;
}

@media screen and (max-width: 1023px) {
  .section_effect .tit {
    font-size: 24px;
  }
  .section_effect .ct {
    padding: 0 40px 40px 40px;
  }
}

@media screen and (max-width: 766px) {
  .section_effect .pic {
    margin: 30px auto 0;
  }
  .section_effect .tit {
    font-size: 20px;
    margin: 20px 0;
  }
  .section_effect .ct {
    font-size: 15px;
    padding: 0 20px 30px 20px;
  }
}

/* 연동방식 */
.section_linkage {
}
.section_linkage .link_img {
  max-width: 1159px;
  margin: 0 2%;
}
.section_linkage .link_img img {
  max-width: 100%;
}

/* 업무편의성 */
.section_conve {
}
.section_conve .spec {
  display: inline-block;
  padding: 1px 10px 2px;
  background-color: #b5b8bb;
  border-radius: 5px;
  font-size: 0.7rem;
  font-weight: 300;
  color: #fff;
}
.section_conve .tit {
  display: block;
  margin: 40px 0 35px;
  font-size: 30px;
  font-weight: 500;
  color: #7ca0f6;
  line-height: 1.35;
  letter-spacing: -0.04em;
}
.section_conve .ct {
  display: block;
  padding: 0 60px 40px 60px;
  font-size: 16px;
  font-weight: 300;
  line-height: 1.45;
}
.section_conve .pic {
  display: inline-block;
  height: 285px;
  margin: 30px 0 0;
  background-repeat: no-repeat;
  background-position: 50% 0;
}
.section_conve .conv1 {
  width: 100%;
  background-image: url("../../assets/img/conve_img1.png");
}
.section_conve .conv2 {
  width: 100%;
  background-image: url("../../assets/img/conve_img2.png");
}
.section_conve .conv3 {
  width: 100%;
  background-image: url("../../assets/img/conve_img3.png");
}

@media screen and (max-width: 1023px) {
  .section_conve .tit {
    margin: 30px 0 25px;
    font-size: 24px;
  }
  .section_conve .ct {
    padding: 0 30px 20px 30px;
  }
  .section_conve .pic {
    background-size: 70%;
  }
}

@media screen and (max-width: 766px) {
  .section_conve .tit {
    margin: 20px 0 15px;
    font-size: 20px;
  }
  .section_conve .ct {
    font-size: 15px;
  }
  .section_conve .pic {
    background-size: 50%;
    height: 200px;
    margin: 0;
  }
  .section_conve .conv1 {
    width: 293px;
  }
  .section_conve .conv2 {
    width: 251px;
  }
  .section_conve .conv3 {
    width: 311px;
  }
}

/* 법적효력 */
.section_law {
  background-color: #ededec;
  background-image: url("../../assets/img/law_bg.jpg");
  background-position: bottom right;
  background-repeat: no-repeat;
}
.section_law .bdr {
  padding: 50px;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.6);
  border-radius: 20px;
}
.section_law .bdr.pd02 {
  padding: 69px 90px;
}
.section_law .bold {
  font-weight: 400;
}

@media screen and (max-width: 1023px) {
  .section_law {
    background-size: 70%;
  }
  .section_law .bdr {
    padding: 30px 20px;
    font-size: 18px;
  }
  .section_law .bdr.pd02 {
    padding: 40px 20px;
  }
}
@media screen and (max-width: 719px) {
  .section_law {
    background-size: 100%;
  }
  .section_law .bdr {
    font-size: 17px;
    line-height: 1.5;
  }
  .section_law .bdr.pd02 {
    padding: 30px 20px;
  }
}

/* 고객 */
.section_customer {
}
.section_customer .tit {
  display: inline-block;
  margin-bottom: 10px;
  font-size: 30px;
  font-weight: 300;
}
.section_customer .cust_img {
  height: 120px;
  margin: 0 auto 50px auto;
  background-repeat: no-repeat;
  max-width: 828px;
  background-size: 100%;
}
.section_customer .cust_img.link {
  background-image: url("../../assets/img/customer_img1.png");
}
.section_customer .cust_img.web {
  background-image: url("../../assets/img/customer_img2.png");
}
.section_customer .cust_btn {
  display: inline-block;
  padding: 10px 60px;
  background-color: #b5b8bb;
  color: #fff;
  font-size: 16px;
  font-weight: 300;
  border-radius: 8px;
}
.Uvideo-con {
  margin-bottom: 30px;
  width: 100%;
  max-width: 720px;
  height: 406px;
  border: 1px solid #eee;
}
.section_customer .ptn_btn {
  display: inline-block;
  margin: 0 10px;
  padding: 10px 60px;
  color: #31c964;
  font-size: 16px;
  font-weight: 300;
  border: 1px solid #31c964;
  border-radius: 8px;
}
.section_customer .ptn_btn.on {
  color: #fff;
  background-color: #31c964;
}
.section_customer .ptn_row {
  margin: 0 auto;
  width: 100%;
  max-width: 720px;
}
.ptnBnn {
  margin: 0 auto 30px;
  max-width: 800px;
  height: 90px !important;
}
@media screen and (max-width: 719px) {
  .section_customer .tit {
    font-size: 22px;
  }
  .Uvideo-con {
    margin-bottom: 0px;
    width: 100%;
    max-width: 360px;
    height: 203px;
  }
  .section_customer .ptn_btn {
    margin-bottom: 10px;
  }
  .ptnBnn {
    height: 60px !important;
  }
}

@media screen and (max-width: 500px) {
  .section_customer .cust_img.link {
    max-width: 350px;
    height: 112px;
    background-image: url("../../assets/img/customer_img1_col.png");
  }
  .section_customer .cust_img.web {
    max-width: 360px;
    height: 124px;
    background-image: url("../../assets/img/customer_img2_col.png");
  }
  .section_customer .tit {
    font-size: 22px;
  }
}

/* 도입문의 */
.section_conve {
}
.section_conve h3,
.section_customer h3 {
  margin-bottom: 30px;
}
.section_conve p {
  font-size: 20px;
  font-weight: 300;
  color: #666;
}
#popMainInq {
  margin: 0 auto;
  padding-top: 50px;
  width: 100%;
  max-width: 760px;
  font-size: 20px !important;
}
#popMainInq .form_box .PMI_ul_form {
  clear: both;
  margin-bottom: 20px;
  padding-bottom: 20px;
  width: 100%;
  height: auto;
  overflow: hidden;
  border-bottom: 1px dashed #c0c4cc;
}
#popMainInq .form_box .PMI_ul_form li {
  margin-bottom: 1rem;
  width: calc(50% - 12px);
  min-height: 52px;
  float: left;
}
#popMainInq .form_box .PMI_ul_form li.st_phone,
#popMainInq .form_box .PMI_ul_form li.st_sum {
  margin-left: 24px;
}
#popMainInq .form_box .PMI_ul_form li.st_inq {
  width: 100%;
}
#popMainInq .form_box .PMI_ul_form li .icon {
  display: block;
  position: absolute;
  width: 40px;
  height: 40px;
  overflow: hidden;
  background: url("../../assets/img/pMI_icon.png") no-repeat;
}
#popMainInq .form_box .PMI_ul_form li.st_email .icon {
  background-position: 0 0;
}
#popMainInq .form_box .PMI_ul_form li.st_phone .icon {
  background-position: 0 -40px;
}
#popMainInq .form_box .PMI_ul_form li.st_cpn .icon {
  background-position: 0 -80px;
}
#popMainInq .form_box .PMI_ul_form li.st_sum .icon {
  background-position: 0 -120px;
}
#popMainInq .form_box .PMI_ul_form li.st_inq .icon {
  background-position: 0 -160px;
}
#popMainInq .form_box .PMI_ul_form li > input {
  margin-left: 46px;
  padding: 12px 20px;
  width: calc(100% - 46px);
  font-size: 18px;
  color: #8d8d8d;
  font-weight: 400;
  border: 1px solid #c0c4cc;
}
#popMainInq .form_box .PMI_ul_form li > textarea {
  resize: none;
  margin-left: 46px;
  padding: 12px 20px;
  width: calc(100% - 48px);
  height: 10em;
  font-size: 18px;
  color: #8d8d8d;
  font-weight: 400;
  border: 1px solid #c0c4cc;
}
#popMainInq .form_box .chk_con {
  position: relative;
  width: 100%;
  height: auto;
  overflow: hidden;
}
#popMainInq .form_box .chk_con .chk_con_chk {
  text-align: center;
  font-size: 0.8rem;
  font-weight: 300;
  margin-bottom: 20px;
}
#popMainInq .form_box .btn_con {
  text-align: center;
}
#popMainInq .form_box .btn_con > button {
  cursor: pointer;
  padding: 15px 50px;
  background: #31c964;
  border-radius: 10px;
  color: #fff;
  font-size: 18px;
}

/**/

#popMainInq .form_box .PMI_ul_form {
  clear: both;
  margin-bottom: 20px;
  padding-bottom: 20px;
  width: 100%;
  height: auto;
  overflow: hidden;
  border-bottom: 1px dashed #c0c4cc;
}
#popMainInq .form_box .PMI_ul_form .icon {
  display: block;
  position: absolute;
  width: 40px;
  height: 40px;
  overflow: hidden;
  background: url("../../assets/img/pMI_icon.png") no-repeat;
}
#popMainInq .form_box .PMI_ul_form .st_email .icon {
  background-position: 0 0;
}
#popMainInq .form_box .PMI_ul_form .st_phone .icon {
  background-position: 0 -40px;
}
#popMainInq .form_box .PMI_ul_form .st_cpn .icon {
  background-position: 0 -80px;
}
#popMainInq .form_box .PMI_ul_form .st_sum .icon {
  background-position: 0 -120px;
}
#popMainInq .form_box .PMI_ul_form .st_inq .icon {
  background-position: 0 -160px;
}
#popMainInq .form_box .PMI_ul_form .PMI_input {
  margin-left: 46px;
}
#popMainInq .form_box .PMI_ul_form .PMI_input fieldset {
  margin-left: 46px;
  padding: 12px 20px;
  width: calc(100% - 46px);
  font-size: 18px;
  color: #8d8d8d;
  font-weight: 400;
  border: 1px solid #c0c4cc;
  border-radius: 0 !important;
}
#popMainInq .form_box .PMI_ul_form textarea {
  resize: none;
  margin-left: 46px;
  padding: 12px 20px;
  width: calc(100% - 48px);
  height: 10em;
  font-size: 18px;
  color: #8d8d8d;
  font-weight: 400;
  border: 1px solid #c0c4cc;
}

@media screen and (max-width: 500px) {
  #popMainInq .form_box .PMI_ul_form li {
    float: none;
    width: 100%;
  }
  #popMainInq .form_box .PMI_ul_form li.st_phone,
  #popMainInq .form_box .PMI_ul_form li.st_sum {
    margin-left: 0;
  }
  #popMainInq .form_box .PMI_ul_form li > input {
    font-size: 16px;
  }
  #popMainInq .form_box .PMI_ul_form li > textarea {
    font-size: 16px;
  }
  #popMainInq .form_box .chk_con .chk_con_chk {
    font-size: 16px;
  }
  #popMainInq .form_box .btn_con > button {
    padding: 10px 30px;
    font-size: 16px;
  }
}

/*테이블*/
.scroll_bs_tbl {
  margin-bottom: 50px;
}
.st_b_tbl {
  border-top: solid 3px #1ebbef;
  border: 1px solid #cfcfcf;
  width: 100%;
}
.st_b_tbl th {
  padding: 10px;
  font-size: 0.9rem;
  border-left: 1px solid #cfcfcf;
  background: #eee;
  font-weight: 300;
}
.st_b_tbl td {
  padding: 20px;
  line-height: 1.4em;
  font-size: 0.8rem;
  border-left: 1px solid #cfcfcf;
  text-align: left;
  font-weight: 300;
  vertical-align: middle;
}

/*=========================================================
  스크롤테이블 애니메이션
=========================================================*/
.scroll_bs_tbl:before {
  display: none;
}

.scroll_bs_tbl:before {
  transform: translateX(0);
  -webkit-transform: translateX(0);
  -moz-transform: translateX(0);
  -ms-transform: translateX(0);
}

.scroll_bs_tbl:before {
  animation-name: scroll_txt;
  -webkit-animation-name: scroll_txt;
  -moz-animation-name: scroll_txt;

  animation-duration: 2s;
  -webkit-animation-duration: 2s;
  -moz-animation-duration: 2s;

  animation-timing-function: linear;
  -webkit-animation-timing-function: linear;
  -moz-animation-timing-function: linear;

  animation-delay: 0s;
  -webkit-animation-delay: 0s;
  -moz-animation-delay: 0s;

  animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;
  -moz-animation-iteration-count: infinite;
}

@keyframes scroll_txt {
  0% {
    transform: translateX(0px);
    -webkit-transform: translateX(0px);
    -moz-transform: translateX(0px);
    -ms-transform: translateX(0px);
  }
  50% {
    transform: translateX(8px);
    -webkit-transform: translateX(8px);
    -moz-transform: translateX(8px);
    -ms-transform: translateX(8px);
  }
  100% {
    transform: translateX(0);
    -webkit-transform: translateX(0);
    -moz-transform: translateX(0);
    -ms-transform: translateX(0);
  }
}

@-webkit-keyframes scroll_txt {
  0% {
    transform: translateY(0px);
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
  }
  50% {
    transform: translateX(8px);
    -webkit-transform: translateX(8px);
    -moz-transform: translateX(8px);
    -ms-transform: translateX(8px);
  }
  100% {
    transform: translateY(0);
    -webkit-transform: translateY(0);
    -moz-transform: translateY(0);
    -ms-transform: translateY(0);
  }
}

@media screen and (max-width: 639px) and (min-width: 1px) {
  .scroll_bs_tbl:before {
    content: "↔︎ 좌우로 스크롤하여 확인하세요";
    display: block;
    font-weight: bold;
    position: relative;
    color: #000;
    font-size: 10px;
    opacity: 0.8;
    float: left;
    margin-bottom: 5px;
    line-height: 1em;
  }
}

@media screen and (max-width: 1279px) and (min-width: 1024px) {
  .st_bs_titlebx h3 {
    font-size: 24px;
  }
  .st_bs_titlebx .sub_text {
    font-size: 14px;
  }
  .st_bs_stitle {
    font-size: 20px;
  }
  .st_b_tbl th {
    font-size: 16px;
  }
  .st_b_tbl th,
  .st_b_tbl td {
    font-size: 13px;
  }
  .st_b_tbl td.bg {
    font-size: 16px;
  }
  .table_head {
    font-size: 13px;
  }
  .scroll_bs_tbl {
    margin-bottom: 40px;
  }
}

@media screen and (max-width: 1023px) and (min-width: 1px) {
  .st_bs_titlebx h3 {
    font-size: 20px;
  }
  .st_bs_titlebx .sub_text {
    font-size: 13px;
  }
  .st_bs_stitle {
    font-size: 18px;
  }
  .st_b_tbl th {
    font-size: 14px;
    padding: 10px 10px;
  }
  .st_b_tbl th,
  .st_b_tbl td {
    font-size: 13px;
    padding: 10px 10px;
  }
  .st_b_tbl td.bg {
    font-size: 14px;
  }
  .table_head {
    font-size: 13px;
  }
  .scroll_bs_tbl {
    margin-bottom: 30px;
  }
}

@media screen and (max-width: 639px) and (min-width: 1px) {
  .st_bs_titlebx h3 {
    font-size: 18px;
  }
  .st_bs_stitle {
    font-size: 16px;
  }
  .st_b_tbl thead th {
    font-size: 14px;
  }
  .scroll_bs_tbl {
    margin-bottom: 25px;
    overflow: hidden;
    overflow-x: scroll;
  }
  .scroll_bs_tbl .st_b_tbl {
    width: 720px;
  }
  .single_cont .scroll_bs_tbl table {
    width: 720px;
  }
}

/* 요금제 */
.section_pay {
}
.section_pay .content {
  padding: 150px 0 100px;
}
.section_pay h3 {
  margin-bottom: 50px;
}
.section_pay .tit {
  font-size: 30px;
  color: #7ca0f6;
}
.section_pay .ct {
  font-size: 16px;
  color: #b5b8bb;
  padding-bottom: 50px;
}
.section_pay .txt {
  display: inline;
  position: relative;
  margin-top: 50px;
  padding-left: 27px;
  font-size: 20px;
  line-height: 1.35;
}
/* .section_pay .txt span.chk{display:inline-block;width:20px;height:23px;padding-top:3px;margin-right:10px;background:url('../../assets/img/main/bul_check.png') 0 3px no-repeat;} */
.section_pay .txt::before {
  display: inline-block;
  content: "";
  position: absolute;
  top: 4px;
  left: 0;
  width: 20px;
  height: 20px;
  background-image: url("../../assets/img/bul_check.png");
  background-repeat: no-repeat;
}
.section_pay .txt2 {
  display: block;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 14px;
  color: #b5b8bb;
}
.mb50 {
  margin-bottom: 50px;
}

.row [class^="box"] {
  float: left;
  margin: 0.5rem 2%;
  min-height: 0.125rem;
}

.box1,
.box2,
.box3,
.box4,
.box5 {
  width: 16%;
}

.tbl_pay {
  border-top: 3px solid #94b4f8;
  box-shadow: 1px 8px 10px rgba(0, 0, 0, 0.1);
}
.tbl_pay {
  padding: 25px 0 50px;
}
.tbl_pay span {
  display: inline-block;
  padding: 0 10px;
  background-color: #9da09f;
  font-size: 17px;
  font-weight: 300;
  color: #fff;
  border-radius: 4px;
}
.tbl_pay strong {
  display: block;
  font-size: 30px;
  font-weight: 400;
  color: #000;
}
.tbl_pay p {
  color: #adb0b3;
}
.tbl_pay .sale {
  padding-top: 20px;
  color: #ff7666;
  font-size: 18px;
}

.section_pay .pay_btn {
  display: inline-block;
  margin-top: 50px;
  padding: 15px 60px;
  background-color: #31c964;
  color: #fff;
  font-size: 18px;
  font-weight: 300;
  border-radius: 10px;
}

@media only screen and (max-width: 1023px) {
  .section_pay .content {
    padding: 130px 20px 50px 20px;
  }
  .tbl_pay {
    padding: 25px 0 30px;
  }
  .section_pay .tit {
    font-size: 26px;
  }
  .box1,
  .box2,
  .box3,
  .box4,
  .box5 {
    width: 46%;
  }
}

@media only screen and (max-width: 500px) {
  .section_pay .content {
    padding: 130px 30px 50px 30px;
  }
  .section_pay .tit {
    font-size: 22px;
  }
  .box1,
  .box2,
  .box3,
  .box4,
  .box5 {
    width: 96%;
  }
  .box1.tbl_pay .sale {
    display: none;
  }
  .tbl_pay span {
    font-size: 14px;
  }
  .tbl_pay strong {
    font-size: 24px;
  }
  .tbl_pay .sale {
    padding-top: 10px;
    font-size: 16px;
  }
}
/* 220923공지팝업 */
.carD_01_h1-221005 {
  padding: 10px 20px;
  width: calc(100% - 68px);
  color: #2b2d2c;
  font-size: 0.8em;
  font-weight: bold;
}
.noti220923_Box {
  margin: 40px 0;
  padding: 20px 12px;
  line-height: 1.4em;
  font-size: 0.8rem !important;
  border: 1px solid #cfcfcf;
}
@media (max-width: 960px) {
  .carD_01_h1-221005 {
    width: 100%;
  }
}
</style>
